<div mat-dialog-content fxFlexfill fxlayoutgap="10px grid">
    <table style="width: auto;">
      <tr>
        <th colspan="2">Queue History</th>
      </tr>
      <tr *ngFor="let row of queueHistoryInfo">
        <td>{{ row.comments }}</td>
        <td>{{ row.eventdatetime | date : 'MMM - yyyy' }}</td>
      </tr>
    </table>
</div>
<div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="end">
  <button mat-raised-button class="theme-button" aria-label="Close" (click)="onClick()">Close</button>
</div>
